// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import tableState from './initialState'
import datatable from './datatable'

// Users Operator
import {
  initialState as operatorState,
  reducers as operatorReducers,
} from 'fc-operator-user'

// Exports
export default createReducer({
  ...tableState,
  ...operatorState,
}, {
  ...datatable.reducers,
  ...operatorReducers,
})
